function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardMastercardLarge = function SvgCardMastercardLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235 153"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 153,
    rx: 16,
    ry: 16,
    style: {
      fill: "#780505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.262 21.633h17.479v28.549h-17.479V21.633Z",
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.065 35.91a18.128 18.128 0 0 1 6.934-14.272c-7.883-6.195-19.297-4.827-25.493 3.057-6.195 7.883-4.827 19.297 3.056 25.493a18.154 18.154 0 0 0 22.437 0 18.124 18.124 0 0 1-6.934-14.277Z",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.376 35.91c0 10.027-8.128 18.155-18.155 18.155-4.07 0-8.021-1.367-11.221-3.883 7.883-6.196 9.252-17.61 3.056-25.493A18.108 18.108 0 0 0 188 21.633c7.883-6.197 19.296-4.831 25.494 3.051a18.155 18.155 0 0 1 3.882 11.221v.005Z",
    style: {
      fill: "#f79e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 62.521c0-.313.085-.621.246-.889l2.706-4.51a1.727 1.727 0 0 1 1.482-.839h12.269c.954 0 1.728.774 1.728 1.728v24.191c0 .954-.774 1.728-1.728 1.728H21.714a1.728 1.728 0 0 1-1.482-.839l-2.706-4.51a1.73 1.73 0 0 1-.246-.889v-15.17Zm20.735-4.511c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728V58.01Zm13.248-1.727c-.954 0-1.728.774-1.728 1.728v12.672c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728V58.011c0-.954-.774-1.728-1.728-1.728h-5.76ZM38.015 72.987c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm13.248 1.728c-.954 0-1.728.774-1.728 1.728v5.76c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728v-5.76c0-.954-.774-1.728-1.728-1.728h-5.76Z",
    style: {
      fill: "#400000",
      fillRule: "evenodd"
    }
  }));
};
export default SvgCardMastercardLarge;